import React from "react";
import { Button } from "../../../components/ui/button";
import { Card } from "../../../components/ui/card";
import { Flame } from "lucide-react";
import useInViewOnce from "../useInViewOnce";

const HeroSection = () => {
  const [setRef, isInView] = useInViewOnce();

  const handleScrollToForm = () => {
    const el = document.getElementById("form-pemesanan");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      ref={setRef}
      className={`mb-12 mt-2 grid gap-8 md:mb-16 md:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)] md:items-center ${
        isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      } transition-all duration-300 ease-out`}
    >
      <div>
        <div className="inline-flex items-center gap-2 rounded-full bg-red-100 px-3 py-1 text-[11px] font-medium text-red-700 shadow-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
          <span>Praktis • Siap Masak • Rasa Restoran</span>
        </div>
        <h1 className="mt-3 text-[1.9rem] font-semibold leading-tight tracking-tight text-slate-900 sm:mt-4 sm:text-4xl md:text-5xl">
          Rasa Aceh Autentik,
          <span className="block text-red-700">Tanpa Ribet di Dapur Kamu</span>
        </h1>
        <p className="max-w-xl mt-3 text-sm leading-relaxed text-slate-600 md:mt-4 md:text-base">
          Bumbu siap masak khas Aceh yang diracik dengan rempah pilihan. Tinggal
          buka kemasan, masak sebentar, dan nikmati rasa restoran tanpa harus
          keluar rumah.
        </p>
        <div className="flex flex-wrap items-center gap-4 mt-6">
          <Button
            className="rounded-full bg-emerald-600 px-6 text-sm font-semibold text-emerald-50 shadow-md transition-transform duration-200 ease-out hover:bg-emerald-700 hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0"
            onClick={handleScrollToForm}
          >
            Pesan Sekarang – Rasa Aceh Asli
          </Button>
          <div className="flex flex-col text-[11px] text-slate-500">
            <span>Praktis • Siap Masak • Rasa Restoran</span>
            <span>Bumbu racikan, bukan sekadar bumbu instan.</span>
          </div>
        </div>
        {/* <dl className="mt-6 grid grid-cols-3 gap-4 text-[11px] text-slate-600 sm:text-xs md:max-w-sm">
          <div>
            <dt className="font-semibold text-slate-900">Waktu masak</dt>
            <dd>Mulai dari 15 menit</dd>
          </div>
          <div>
            <dt className="font-semibold text-slate-900">Porsi</dt>
            <dd>3–4 orang / kemasan</dd>
          </div>
          <div>
            <dt className="font-semibold text-slate-900">Kualitas</dt>
            <dd>Rasa restoran, harga rumahan</dd>
          </div>
        </dl> */}
      </div>

      <div className="relative">
        {/* Glow background */}
        <div className="absolute inset-0 -z-10 rounded-3xl bg-gradient-to-br from-primary/30 via-secondary to-accent/30 blur-xl" />

        <Card className="relative p-5 overflow-hidden border shadow-md rounded-3xl border-border bg-card/90 backdrop-blur">
          {/* HEADER */}
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs font-semibold tracking-widest uppercase text-emerald-600">
                Bumbu Aceh Siap Masak
              </p>
              <p className="mt-1 text-sm font-semibold text-foreground">
                Rasa Restoran, Tanpa Ribet
              </p>
              <p className="mt-1 text-xs text-muted-foreground">
                Cocok untuk nasi goreng, mie Aceh, hingga masakan berkuah.
              </p>
            </div>

            <div className="flex items-center justify-center shadow-md w-14 h-14 rounded-2xl bg-emerald-600 text-emerald-50">
              <Flame className="w-7 h-7" />
            </div>
          </div>

          {/* FEATURES */}
          <div className="grid grid-cols-2 gap-3 mt-4 text-[11px] text-muted-foreground">
            <div className="px-3 py-2 rounded-xl bg-secondary/80">
              <p className="font-medium text-foreground">Tinggal tumis</p>
              <p>Takaran pas, rasa konsisten.</p>
            </div>

            <div className="px-3 py-2 rounded-xl bg-secondary/80">
              <p className="font-medium text-foreground">Rempah asli</p>
              <p>Bukan rasa instan pabrikan.</p>
            </div>

            <div className="px-3 py-2 rounded-xl bg-secondary/80">
              <p className="font-medium text-foreground">Hemat waktu</p>
              <p>Masak cepat, cocok harian.</p>
            </div>

            <div className="px-3 py-2 rounded-xl bg-secondary/80">
              <p className="font-medium text-foreground">Serbaguna</p>
              <p>Bisa kuah & tumis.</p>
            </div>
          </div>

          {/* FOOT NOTE */}
          <p className="mt-4 text-[10px] text-muted-foreground">
            *Disimpan di kulkas, tahan beberapa hari setelah dibuka.
          </p>
        </Card>
      </div>
    </section>
  );
};

export default HeroSection;
